import { MediaType } from '@wix/ambassador-media-site-media-v1-file-descriptor/types';
const map = {
  picture: MediaType.IMAGE,
  music: MediaType.AUDIO,
  document: MediaType.DOCUMENT,
  video: MediaType.VIDEO,
  archive: MediaType.ARCHIVE,
  shape: MediaType.VECTOR,
  swf: MediaType.VECTOR,
  // todo: change to swf mediaType once created
  site_icon: MediaType.IMAGE,
  secure_picture: MediaType.IMAGE,
  secure_music: MediaType.IMAGE,
  secure_document: MediaType.DOCUMENT,
  secure_video: MediaType.VIDEO,
  secure_archive: MediaType.ARCHIVE,
  secure_raw: 'RAW',
  '3d': MediaType.MODEL3D
};
export const mapMediaType = mediaType => map[mediaType];
export const getMediaTypesFromString = mediaTypesString => {
  const mediaTypes = mediaTypesString.split(',');
  const types = new Set();
  for (const mediaType of mediaTypes) {
    types.add(mapMediaType(mediaType));
  }
  return Array.from(types);
};
//# sourceMappingURL=MediaType.mappers.js.map